module.exports = __webpack_public_path__ + "img/covidcover1.eb160c66.webp";